import { InspectableUser } from "../users/SDKInspectableUser";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Model Definition
export class DesignSystemContactList {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.workspace = model.contacts.workspace.map((u) => {
            return new InspectableUser(u);
        });
        this.designSystem = model.contacts.designSystem.map((u) => {
            return new InspectableUser(u);
        });
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Utilities
    /**
     * Get the list of emails that have managing permissions on the workspace-level.
     */
    getWorkspaceEmails() {
        return this.workspace.map((u) => u.email);
    }
    /**
     * Get the list of emails that have managing permissions on the design system-level.
     */
    getDesignSystemEmails() {
        // Fallback to workspace if there are no design system contacts
        const users = this.designSystem.length > 0 ? this.designSystem : this.workspace;
        return users.map((u) => u.email);
    }
}
